import { render, staticRenderFns } from "./tinkAboutData.vue?vue&type=template&id=20d31a8a"
import script from "./tinkAboutData.vue?vue&type=script&lang=js"
export * from "./tinkAboutData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports